import React from "react"
import styled from "styled-components"
import {Badges} from "./Badges"
import {DataTable} from "./DataTable"
import {DataTables} from "./DataTables"
// import {Hero} from "./Hero"
import {ReportCard} from "./ReportCard"
import {ReportCardHeader} from "./ReportCardHeader"
import {TripDetails} from "./TripDetails"

const Report = (props) => {
  return (
    <>
      {/*<Hero message={props.heroMessage} title={props.heroTitle} />*/}
      <TripDetails
        assigneeId={props.assigneeId}
        assigneeName={props.assigneeName}
        endDate={props.endDate}
        endLocation={props.endLocation}
        organization={props.organization}
        renderDate={props.renderDate}
        startDate={props.startDate}
        startLocation={props.startLocation}
      />
      <Badges badges={props.badges} renderValue={props.renderValue} />
      <ReportCard header={<ReportCardHeader>Compensation</ReportCardHeader>}>
        <CardChildrenDiv>
          <DataTables
            columns={props.columns}
            renderValue={props.renderValue}
            tables={props.tables}
          />
        </CardChildrenDiv>
      </ReportCard>
      <ReportCard header={<ReportCardHeader>Demographics</ReportCardHeader>}>
        <CardChildrenDiv>
          <DataTable
            columns={props.demographics.columns}
            firstColumnWidth="20%"
            rows={props.demographics.rows}
          />
        </CardChildrenDiv>
      </ReportCard>
    </>
  )
}

const CardChildrenDiv = styled.div`
  padding: ${(props) => props.theme.gutter}px;
`

Report.defaultProps = {
  heroMessage:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  heroTitle: "Your report data has changed.",
}

export {Report}
